import styled from 'styled-components';

export const VerifyAccountContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 15rem 0 20rem;

    section {
        max-width: 60rem;
    }
`;

export const SelectVerificationMethod = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > img {
        width: 20rem;
        margin-bottom: 4rem;
    }

    .heading {
        text-align: center;
        max-width: 30rem;
        margin-bottom: 5rem;

        h1 {
            font-size: 2.5rem;
            margin-bottom: 2rem;
        }

        p {
            font-size: 1.6rem;
            line-height: 150%;
        }
    }

    .verification-methods-selects {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 3rem;

        width: 100%;
        margin-bottom: 7rem;

        .verification-method {
            position: relative;
            z-index: 100;

            cursor: pointer;
            user-select: none;

            &::before {
                content: "";
                position: absolute;
                top: -2px;
                left: -2px;
                right: -2px;
                bottom: -2px;

                background: red;
                border-radius: .5rem;
            }

            div {
                position: relative;
                z-index: 100;

                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;

                width: 100%;
                height: 6rem;

                background: #fff;
                border-radius: .5rem;

                pointer-events: none;

                i {
                    position: absolute;
                    top: 0;
                    left: 0;
                    transform: translate(-50%, -50%);

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    font-size: 2rem;

                    width: 2.1rem;
                    height: 2.1rem;

                    background: #fff;
                    /* border-radius: 50%; */

                    &::before {
                        position: relative;
                        z-index: 100;

                        background: linear-gradient(45deg, #ec6625, #f31d2f);
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }

                img {
                    width: 2rem;
                    height: 2rem;
                    object-fit: contain;

                    margin-right: 1rem;
                }

                strong {
                    font-size: 1.5rem;

                    background: linear-gradient(45deg, #ec6625, #f31d2f);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            & {
                filter: grayscale(1);

                div {
                    i {
                        display: none;
                    }
                }

                &.active {
                    filter: grayscale(0);

                    div {
                        i {
                            display: block;
                        }
                    }
                }
            }
        }
    }
`;